import GroupCardAccordionFormWrapper from './GroupCardAccordionFormWrapper';

export default GroupCardAccordionFormWrapper;
